<template>
  <div class="work-box" ref="workBox">
    <div class="header-title" ref="headerTop">
      <div @click="back" class="header">
        <i class="iconfont">&#xe604;</i>
      </div>
      <div class="swiper">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) in swiperList" :key="index">
            <img class="swiper_img" :src="item.imgUrl ? url + item.imgUrl : defaultimg" @click="goDetail(item)" :onerror="errorDefaultImg">
          </swiper-slide>
          <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
      </div>
      <div class="mess-title">
        <div class="shop-title">
          <div class="shop-left">
            <img :src="headerInfo.imgUrl ? url + headerInfo.imgUrl : defaultimg" :onerror="errorDefaultImg">
          </div>
          <div class="shop-right">
            <div class="shop-right-title">{{headerInfo.shops}}</div>
            <div class="shop-right-item shop-right-phone">
              <i class="iconfont">&#xe68d;</i>
              <span>{{introduceInfo.tel}}</span>
            </div>
            <div class="shop-right-address">
              <i class="iconfont">&#xe686;</i>
              <span>{{introduceInfo.address}}</span>
            </div>
          </div>
        </div>
        <div class="produce-title">
          <ul class="tabbtn">
            <li :class="{'li-active': active == index}" @click="handleClick(index)" v-for="(item,index) in tabList" :key="index">{{item}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content-box">
      <common-business :introduceInfo='introduceInfo' v-show='active == 0'></common-business>
      <common-detail v-show='active == 1'></common-detail>
      <common-certificate :introduceInfo='introduceInfo' v-show='active == 2'></common-certificate>
    </div>
  </div>
</template>

<script>
import url from '@/common/common.js'
import CommonBusiness from '@/pages/my_store/common/business/Business'
import CommonDetail from '@/pages/my_store/common/detail/Detail'
import CommonCertificate from '@/pages/my_store/common/certificate/Certificate'
export default {
  name: 'storeHeader',
  props: {
    headerInfo: Object,
    introduceInfo: Object,
    swiperList: Array
  },
  components: {
    CommonBusiness,
    CommonDetail,
    CommonCertificate
  },
  data () {
    return {
      active: 0,
      height: '300px',
      url,
      tabList: ['企业介绍', '商品信息', '相关资质'],
      swiperOption: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          loop: true,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            let customPaginationHtml = ''
            for (let i = 0; i < total; i++) {
              // 判断哪个分页器此刻应该被激活
              if (i === current - 1) {
                customPaginationHtml += '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>'
              } else {
                customPaginationHtml += '<span class="swiper-pagination-customs"></span>'
              }
            }
            return '<span class="swiperPag">' + customPaginationHtml + '</span>'
          }
        },
        autoplay: true,
        speed: 400,
        paginationType: 'fraction'
      },
      errorDefaultImg: 'this.src="/static/img/defaultimg.jpg"',
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  mounted () {
    let that = this
    setTimeout(function () {
      that.height = (that.$refs.workBox.offsetHeight - that.$refs.headerTop.offsetHeight) + 'px'
    }, 1000)
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleClick (index) {
      this.active = index
    },
    goDetail (info) {
      if (info.goodId && info.goodId !== 0) {
        this.$router.push({
          path: '/detail/' + info.goodId
        })
      }
    }
  }
}
</script>

<style scoped>
*{margin: 0; padding: 0;}
a{ text-decoration: none; color: #000;}
body{ background-color: #fff; font-family: '微软雅黑'; color: #000;}
.work-box{
  background: #f8f8f8;
  min-height: 100vh;
}
.header{
  position: absolute;
  top: 34px;
  left: 7px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #777777;
  color: #fff;
  z-index: 2;
  line-height: 22px;
  text-align: center;
  }
.header .iconfont{ font-size: 18px;color: #fff;}
.search{ padding: 13px 10px; width: 87%; opacity: 0.7;}
.search-box{ display: flex; justify-content: space-around; background-color: #efefef; border-radius: 3px;}
.search input{ width: 360px; border: 0; border-radius: 3px; background-color: #efefef;}
input::-webkit-input-placeholder{ color:#7f7f7f; font-size: 13px; line-height: 15px; font-family: Arial,"Microsoft YaHei";}
.search .iconfont{ line-height: 32px; margin: 0 8px; font-size: 14px;}
.head img{ width: 100%; opacity: 0.7; height: 158px; position: relative;}
.header-title{position: relative;}
.produce-title{
  background: #FFFFFF;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.08);
}
.produce-title ul{
  display: flex;
  justify-content: space-around;
  font-size: 14px;
  font-weight: bold;
  color: #AAAAAA;
  box-sizing: border-box;
 }
 .produce-title ul li{
    padding: 10px 0 8px;
 }
 .produce-title .li-active{
   color: #FF8129;
   border-bottom: 1px solid #FF8129;
 }
.swiper >>> .swiper-container{ z-index: 0;}
.swiper_img{ width: 100%; height:200px;}
.swiper-pagination{
  bottom: 20px;
}
.swiper-pagination >>> .swiperPag{
  display: flex;
  position: relative;
  justify-content: center;
}
.swiper-pagination >>> .swiper-pagination-customs {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #D9D9D9;
  opacity: 0.6;
  border-radius: 50%;
  margin-right: 10px;
}
/*自定义分页器激活时的样式表现*/
.swiper-pagination >>> .swiper-pagination-customs-active {
  width: 10px;
  height: 5px;
  background: #fff;
  opacity: 1;
  border-radius: 5px;
}
.mess-title{
  position: relative;
  margin-top: -10px;
  width: 100%;
  background: #fff;
  opacity: 1;
  border-radius: 10px 10px 0px 0px;
  overflow: hidden;
  z-index: 999;
}
.shop-title{
  padding: 0 20px;
  display: flex;
  align-items: center;
}
.shop-left{
  margin: 20px 13px 14px 0;
  width: 70px;
  height: 70px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
}
.shop-left img{
  width: 100%;
  height: 100%;
}
.shop-right-title{
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.shop-right-phone{
  margin-bottom: 5px;
}
.shop-right-item .iconfont,.shop-right-address .iconfont{
  font-size: 14px;
  color: #FF8129;
}
.shop-right-item span,.shop-right-address span{
  font-size: 12px;
  color: #aaaaaa;
}
.content-box{
  padding: 10px 14px 12px;
  /* overflow: scroll; */
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/my_store/components/Header.vue